import React, { memo, useCallback, useEffect, useState } from 'react';
import { useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { Switch, Route, Redirect } from 'react-router-dom';

import styles from './Game.module.less';
import { getGameTabs, getGameExtScreen } from '../../actions/game';
import { logging, logPostInfo } from '../../actions/log';

import Loading from '../../components/Loading/Loading';
import GameMenu from './GameMenu/Menu';
import GameRank from './GameRank/GameRank';
import GameCardPage from './GameCardPage/GameCardPage';
import GameCategory from './GameCategory/GameCategory';
import GameExtScreen from '../../components/Game/GameExtScreen/GameExtScreen';

import { changeClass, removeClass, hasClass } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectGameInfo = createSelector(
  state => state.game,
  game => game,
);
const selectwidowSize = createSelector(
  state => state.layout,
  layout => layout.widowSize,
);

let game_show_adv_st_index = 0;
let game_show_adv_st_index2 = 0;
function Game() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const logInfoData = useSelector(selectLogInfo);
  const windowSize = useSelector(selectwidowSize);

  const { path, url } = useRouteMatch();
  const { menu: tabs, gameExtScreen } = useSelector(selectGameInfo);

  const [boxNode, setBoxNode] = useState(null);
  const [advNode, setAdvNode] = useState(null);
  const [isNeedShowAdv, setIsNeedShowAdv] = useState(null);
  const [isShowAdv, setIsShowAdv] = useState(false);
  const [initTime, setInitTime] = useState(Date.now());

  const pagePvLog = useCallback(() => {
    dispatch(
      logPostInfo({
        source: 'Game',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });
  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Game`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);
  useEffect(() => {
    return () => {
      sessionStorage.setItem('Game_Adv_Is_Show', '');
    };
  }, []);
  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });
  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    // 首先去获取一次是否有需要展示的adv
    dispatch(getGameExtScreen());
    if (!tabs || tabs.length === 0) {
      dispatch(
        getGameTabs({
          pageType: 'newGame',
        }),
      );
    }
  }, []);
  useActivate(() => {
    if (!tabs || tabs.length === 0) {
      dispatch(
        getGameTabs({
          pageType: 'newGame',
        }),
      );
    }
  });

  useUnactivate(() => {
    if (advNode && boxNode) {
      advNode.style.height = 0;
      boxNode.style.marginTop = 0;
      advNode.setAttribute('data-jump', '1');
      boxNode.setAttribute('data-jump', '1');
      sessionStorage.setItem('Game_Adv_Is_Show', '');
      setIsShowAdv(false);

      removeClass(advNode, styles.game_adv_visible);
      removeClass(advNode, styles.game_adv_hiddle);
      removeClass(boxNode, styles.game_box_hiddle);
      removeClass(boxNode, styles.game_box_visible);
    }
  }, [advNode, boxNode]);

  useEffect(() => {
    // 获取数据中
    if (!gameExtScreen || !gameExtScreen?.loading) {
      return;
    }
    if (
      gameExtScreen &&
      gameExtScreen?.loading &&
      gameExtScreen?.data &&
      (gameExtScreen?.data?.img || gameExtScreen?.data?.videoUrl)
    ) {
      sessionStorage.setItem('Game_Adv_Is_Show', 1);
      setIsNeedShowAdv(true);
      setIsShowAdv(true);
    } else {
      setIsShowAdv(false);
      setIsNeedShowAdv(false);
    }
  }, [gameExtScreen]);

  useEffect(() => {
    // 控制多少秒后收起adv
    if (isNeedShowAdv && gameExtScreen?.data && advNode && boxNode) {
      let time = parseInt((gameExtScreen?.data?.showTime || 6) * 1000);
      if (time) {
        clearTimeout(game_show_adv_st_index);
        clearTimeout(game_show_adv_st_index2);
        game_show_adv_st_index = setTimeout(() => {
          scrollHiddenAdv();
        }, time);
      }
    }
  }, [isNeedShowAdv, gameExtScreen, advNode, boxNode]);

  const scrollVisibleAdv = useCallback(() => {
    sessionStorage.setItem('Game_Adv_Is_Show', 1);
    // 收起adv
    if (isNeedShowAdv) {
      clearTimeout(game_show_adv_st_index);
      clearTimeout(game_show_adv_st_index2);

      let advDom = document.getElementById('game_page_adv');
      let boxDom = document.getElementById('game_page_box');
      advDom.setAttribute('data-jump', '');
      boxDom.setAttribute('data-jump', '');
      changeClass(advDom, styles.game_adv_visible, styles.game_adv_hiddle);
      changeClass(boxDom, styles.game_box_hiddle, styles.game_box_visible);

      setIsShowAdv(true);
    }
  }, [isNeedShowAdv]);

  const scrollHiddenAdv = useCallback(() => {
    // 收起adv
    if (isNeedShowAdv) {
      clearTimeout(game_show_adv_st_index);

      let advDom = document.getElementById('game_page_adv');
      let boxDom = document.getElementById('game_page_box');

      if (advDom.getAttribute('data-jump') && boxDom.getAttribute('data-jump')) {
        return;
      }
      changeClass(advDom, styles.game_adv_hiddle, styles.game_adv_visible);
      changeClass(boxDom, styles.game_box_visible, styles.game_box_hiddle);
      // if (hasClass(advDom, styles.game_adv_visible)) {
      //   changeClass(advDom, styles.game_adv_hiddle, styles.game_adv_visible);
      // }
      // if (hasClass(boxDom, styles.game_box_hiddle)) {
      //   changeClass(boxDom, styles.game_box_visible, styles.game_box_hiddle);
      // }

      setIsShowAdv(false);

      game_show_adv_st_index2 = setTimeout(() => {
        sessionStorage.setItem('Game_Adv_Is_Show', '');
      }, 300);
    }
  }, [isNeedShowAdv]);

  const handleAnimationEnd = useCallback(() => {
    // sessionStorage.setItem('Game_Adv_Is_Show', '');
  }, []);

  const handleScrollAdv = useCallback(
    e => {
      // 滚动后 就收起adv
      if (e?.target?.scrollTop >= 5 && isNeedShowAdv) {
        scrollHiddenAdv();
      }
      if (e === 'hidden') {
        scrollHiddenAdv();
      }
    },
    [isNeedShowAdv],
  );

  if (isNeedShowAdv === null || !gameExtScreen || !(tabs.length > 0)) {
    return (
      <div className={styles.game_page} id={'game_content'}>
        <div className={`loading`}>
          <Loading styleType={'black'} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.game_page}>
      {isNeedShowAdv &&
        gameExtScreen &&
        gameExtScreen.data &&
        !isShowAdv &&
        tabs &&
        tabs[0] &&
        tabs[0].code &&
        location?.pathname?.indexOf(tabs[0].code) > -1 && (
          <div
            className={`game_page_adv_pull ${styles.game_page_adv_pull}`}
            style={{
              right:
                windowSize?.width > 1920
                  ? (document.body.clientWidth - 180 - 1660) / 2 - 8
                  : '34px',
            }}
            onClick={() => {
              let targetContent_ = {};
              try {
                targetContent_ = JSON.parse(gameExtScreen?.data?.targetContent || '{}');
              } catch (error) {}
              dispatch(
                logging({
                  category: 'C',
                  action: 'Game_Negative_Screen_Spread',
                  label: '',
                  param2: {
                    source: `Game_Negative_Screen`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    type: gameExtScreen?.data?.targetType,
                    id: { ...targetContent_ },
                  },
                  param3: gameExtScreen?.data?.bizInfo,
                }),
              );
              scrollVisibleAdv();
              if (advNode) {
                advNode.scrollTop = 0;
              }
            }}
          >
            <div className={`game_page_adv_pull_icon`}></div>
            <div className={`game_page_adv_pull_text`}>每日一鉴</div>
          </div>
        )}
      {isNeedShowAdv && gameExtScreen && gameExtScreen.data && (
        <>
          <div
            className={`game_page_adv`}
            id={'game_page_adv'}
            ref={r => setAdvNode(r)}
            onScroll={handleScrollAdv}
            pagescroll="PCStore_Page_Scroll"
            onAnimationEnd={() => {
              handleAnimationEnd();
            }}
          >
            <GameExtScreen
              data={gameExtScreen}
              logInfo={{ tag: 'Game' }}
              handleScrollAdv={handleScrollAdv}
              isShowAdv={isShowAdv}
            />
          </div>
        </>
      )}
      <div
        className={isNeedShowAdv ? `game_page_box` : `game_page_box_`}
        id={'game_page_box'}
        ref={r => setBoxNode(r)}
        onClick={() => {
          scrollHiddenAdv && scrollHiddenAdv();
        }}
      >
        {tabs.length > 0 && <GameMenu base={url} tabs={tabs} />}
        {tabs.length > 0 && (
          <div className={`game_page_cont`}>
            {tabs.length > 0 && (
              <Switch>
                {tabs.map(tab => {
                  if (tab.contentType === '1') {
                    return (
                      <Route
                        key={tab.code}
                        exact
                        path={`${path}/${tab.code}`}
                        render={() => (
                          <GameCardPage
                            code={tab.code}
                            source={tab.source}
                            scrollAdv={scrollHiddenAdv}
                          />
                        )}
                      />
                    );
                  }

                  if (tab.contentType === '3') {
                    return (
                      <Route
                        key={tab.code}
                        exact
                        path={`${path}/${tab.code}/:code?`}
                        render={() => (
                          <GameRank
                            source={tab.source}
                            code={tab.code}
                            scrollAdv={scrollHiddenAdv}
                          />
                        )}
                      />
                    );
                  }

                  if (tab.contentType === '2') {
                    return (
                      <Route
                        key={tab.code}
                        exact
                        path={`${path}/${tab.code}`}
                        render={() => (
                          <GameCategory
                            source={tab.source}
                            code={tab.code}
                            scrollAdv={scrollHiddenAdv}
                          />
                        )}
                      />
                    );
                  }

                  // if (tab.contentType === '3') {
                  //   return (
                  //     <Route
                  //       key={tab.code}
                  //       exact
                  //       path={`${path}/${tab.code}/:code?`}
                  //       render={() => <Top source={tab.source} code={tab.code} scrollNode={node} />}
                  //     />
                  //   );
                  // }

                  return null;
                })}
                <Redirect to={`${url}/${tabs[0].code}`} />
              </Switch>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
export default () => (
  <KeepAlive name="game">
    <Game />
  </KeepAlive>
);
